import React from "react";
import { Table } from "antd";
import { classesStudent } from "service/service";
import Style from "./sutdentTable.module.scss";
import { ColumnProps } from "antd/lib/table/interface";

interface IStudentTableProps {
    list: classesStudent[];
}

const StudentTable: React.FC<IStudentTableProps> = ({ list }) => {
    const columns: ColumnProps<classesStudent>[] = [
        {
            title: "序号",
            dataIndex: "index",
            key: "index",
            render: (text, column, index) => index + 1
        },
        { title: "学号", dataIndex: "studentNo", key: "studentNo" },
        { title: "姓名", dataIndex: "name", key: "name" },
        { title: "性别", dataIndex: "sex", key: "sex" },
        { title: "院系", dataIndex: "department", key: "department" },
        { title: "专业", dataIndex: "subject", key: "subject" },
        { title: "班级", dataIndex: "className", key: "className" }
    ];

    return (
        <Table
            dataSource={list}
            columns={columns}
            pagination={false}
            rowKey="studentNo"
            className={Style.tableBorder}
        />
    );
};

export default StudentTable;
